import qs from 'qs';

interface IPaymentProblems {
  [key: string]: { [key: string]: readonly string[] };
}

const allowedRoutesMap: IPaymentProblems = {
  default: {
    paymentproblem: Object.freeze(['/subscription', '/subscription/pricing/payment']),
    'chargeback-fee-unpaid': Object.freeze(['/subscription'])
  },
  stripe: {
    paymentproblem: Object.freeze(['/subscription']),
    'chargeback-fee-unpaid': Object.freeze(['/subscription'])
  },
  digistore: {
    paymentproblem: Object.freeze(['/subscription', '/subscription/pricing/payment']),
    'chargeback-fee-unpaid': Object.freeze(['/subscription'])
  }
};

export const SHOP_PAYMENT_SETTINGS_ROUTE = '/shop/payment-settings?tab=documents';
export const SUBSCRIPTION_ROUTE = '/subscription';
export const PAYMENT_SETUP_ROUTE = '/subscription/pricing/payment';

export interface IGetPaymentProblemRedirectParams {
  pathname: string;
  search: string;
  paymentProvider: string;
  subscriptionState: string;
  isPaymentProblemSubscription: boolean;
  isPaymentProblemShop: boolean;
}

export function getPaymentProblemRedirect({
  pathname,
  search,
  paymentProvider,
  subscriptionState,
  isPaymentProblemSubscription,
  isPaymentProblemShop
}: IGetPaymentProblemRedirectParams): string | null {
  const searchParams = qs.parse(search.substring(1));

  // The shop block has priority over the subscription problem (mirrors
  // BLOCK_REASON_PRIORITY on the backend): while it is active, the shop
  // payment settings page is the only destination and the guards below must
  // not redirect away from it, otherwise the two guards bounce the user
  // between /subscription and /shop/payment-settings in an infinite loop.
  if (isPaymentProblemShop) {
    return pathname.includes('payment-settings') ? null : SHOP_PAYMENT_SETTINGS_ROUTE;
  }

  if (
    (subscriptionState === 'payment_setup_problem' || searchParams.setup_failed) &&
    searchParams.is_setup !== 'true' &&
    pathname !== PAYMENT_SETUP_ROUTE
  ) {
    const queryString = searchParams.setup_failed ? search : '';

    return PAYMENT_SETUP_ROUTE + queryString;
  }

  const allowedRoutes =
    (allowedRoutesMap[paymentProvider] || allowedRoutesMap.default)[subscriptionState] || [];

  if (isPaymentProblemSubscription && !allowedRoutes.includes(pathname)) {
    return SUBSCRIPTION_ROUTE;
  }

  return null;
}
